import type { EntityTemplateEntity } from "@/entities/entity-template";

import { useEffect, useState } from "react";

import { useUpdateEntityTemplate } from "@/entities/entity-template";
import { useApiErrorHandler } from "@/modules/api-errors";
import {
  useAppSaveBar,
  useAppSaveBarHandler,
  useAppSaveBarSync,
} from "@/modules/app-save-bar";

import { TECHNICAL_FORM_EDITOR_SCOPE } from "./asset-type-template-form-editor.constant";

const SCOPE = TECHNICAL_FORM_EDITOR_SCOPE;

export const useTemplateSchema = (
  template: EntityTemplateEntity | undefined
) => {
  const initSchema = template?.content;
  const [schema, setSchema] = useState(initSchema);
  const { setSaveBar } = useAppSaveBar(SCOPE);
  const { onError } = useApiErrorHandler();
  const { mutate, isPending } = useUpdateEntityTemplate(template?.id || 0);

  useEffect(() => {
    setSchema(initSchema);
  }, [initSchema]);

  const onUpdate = (modifiedSchema: object, isRegistrable: boolean) => {
    setSchema(modifiedSchema);
    if (isRegistrable) setSaveBar("dirty", true);
  };

  const onCancel = () => {
    setSchema(initSchema);
    setSaveBar("dirty", false);
  };

  const onSave = () => {
    const data = {
      content: schema,
    };
    mutate(data, {
      onSuccess: () => setSaveBar("dirty", false),
      onError,
    });
  };

  // Sync save bar
  useAppSaveBarHandler(SCOPE, { onSave, onCancel });
  useAppSaveBarSync(SCOPE, "saving", isPending);

  return {
    schema,
    onUpdate,
  };
};
